import image1 from '@/assets/images/news/detail/20200422/1.png';
import image2 from '@/assets/images/news/detail/20200422/2.jpg';
import image3 from '@/assets/images/news/detail/20200422/3.png';

export default {
  id: '20200422', //  模块 id
  title: '叮咚买菜正式进京 首批18个前置仓开业', // 标题
  origin: '2020-04-22 11:35:06 来源：灵兽网', // 新闻来源
  editor: '编辑：李又寻欢', // 编辑者
  content: [
    {
      type: 0,
      text:
        '4月21日，国内领先的生鲜新零售创业公司 “叮咚买菜”正式在北京展开服务，作为起步上海的生鲜新零售企业，叮咚买菜以“品质确定、时间确定、品类齐全、29分钟送到家”的高性价比和极致快速的用户体验深受市民青睐。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '叮咚买菜首批开设的18个前置仓，分布在回龙观、双桥、青年路等社区，未来还将不断开设新的前置仓达到全城覆盖。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 0,
      text: '首次北上',
      isIndent: false,
    },
    {
      type: 0,
      text: '投入数百万元实行“0元购”',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '据叮咚买菜透露，此次北上，除了恪守“绝不把不好的菜卖给用户”的价值观，扎扎实实卖好菜、做好服务，还将投入数百万元来做惠民促销，让利消费者。不仅有108元的新人大礼包，还有不限量的“0元券”发放，用户可以0元换购蔬菜、牛奶、水果、鱼虾、肉类等各种生鲜。各种大力度的促销活动将持续近1个月。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '记者来到位于朝阳区青年路的叮咚买菜前置仓，发现叮咚买菜前置仓与传统门店不同，只做手机app售卖，用户无需上门，只要在手机上下单，就能享受最快29分钟送货上门服务。前置仓的面积大概有200多平米，有1800多种品类，设置了冷藏、冷冻、常温等不同储存区域，以及养殖活鱼活虾的水产区，存放有不同保鲜要求的商品，保障新鲜品质。',
      isIndent: false,
    },
    {
      type: 1,
      title: ['叮咚买菜前置仓内的水产间'],
      src: [image2],
    },
    {
      type: 0,
      text:
        '同时，叮咚买菜通过大数据和人工智能来管理后台，进行货品预测，让每个前置仓更精准满足附近小区的需求，实现精准化的丰富选择；也让前置仓更好控制损耗，目前叮咚买菜的损耗率低于1%。在供应链端，叮咚买菜通过走向原产地，进行源头集中采购，降低原来农业产业的很多中间环节，降低成本，降低损耗，使得生鲜的价格进一步降低。目前叮咚买菜已深入云南大理、贵州遵义等地区，投资建设多个“叮咚买菜合作种植/养殖合作基地”。叮咚买菜目前80%的食材来自原产地直采。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image3],
    },
    {
      type: 0,
      text: '增长最快的生鲜电商',
      isIndent: false,
    },
    {
      type: 0,
      text: '以行动诠释“自来水哲学”',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '叮咚买菜于2017年5月正式上线，成立于全国生鲜电商竞争最激烈的上海，短短三年的时间，在上海、杭州、苏州、深圳等市场都深受用户青睐，日订单量突破60万，次月复购率超过60%；2020年2月单月营收超过12亿，是生鲜电商中增长最快的创业公司之一。在长三角和珠三角市场的成绩验证了叮咚买菜的模式深受用户认可，服务北京市场是叮咚买菜又一跨区域的扩张和渗透。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '叮咚买菜CEO梁昌霖表示，叮咚买菜的使命是“自来水哲学”，让美好的食材像自来水一样，触手可得，普惠万众，服务北京市场，是进一步实践“自来水哲学”。叮咚买菜的“自来水哲学”，一方面是直接送菜上门，极致便利，买菜就像使用自来水一样方便；第二，是区域内的全覆盖。第三，自来水是普惠万众的。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '梁昌霖解释“自来水哲学”：自来水无色无味、不刺激、不昂贵，但是生命之源。其实吃菜也一样，不分高低贫富，人们都希望吃得好、吃得健康，也希望有很多新奇和变化。卖菜是社会基础设施，满足所有人对美好生活的追求。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '叮咚买菜的“自来水哲学”在这次疫情中也得到充分体现。疫情期间，叮咚买菜率先推出“过年不打烊”、“无接触配送”、“与餐饮企业共享员工”、“集约式电动车送菜”等各项创新举措，在这次疫情中，承担起了为数千万市民送菜上门的重要工作，保证家庭用户足不出户就能吃上新鲜菜的需求，因此成为“保供应、保民生”的重要力量。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '梁昌霖表示，此次进入北京市场，叮咚买菜在供应链方便也有所调整，根据北京市场的特殊需求，对北京地区的供应链进行调整，保持相对的独立性，更好地去贴合北京市民的喜好。同时，在服务、产品品质等方面将严格保持叮咚买菜一贯的高水准。（灵兽传媒 李又寻欢）',
      isIndent: false,
    },
  ],
};
